import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";

import { App } from "./containers/App/App";

import { isCookieAccepted, setCookies, setEvent } from "./utils/utils";

window.CWC = {
  componentRender: function (config) {
    this.root = ReactDOM.createRoot(document.getElementById("cms-web-consent-root"));

    this.root.render(
      <React.StrictMode>
        <App config={config} />
      </React.StrictMode>,
    );
  },

  destroy: function () {
    this.root.unmount();
  },

  loaded: function () {
    setEvent("cms-web-consent-root-loaded");
  },

  render: function (config) {
    if (config.link) {
      this.componentRender(config);
    } else {
      if (!isCookieAccepted()) {
        this.componentRender(config);
      }
    }
  },

  setCookie: function (allCookies) {
    const cookies = {
      necessaryCookies: true,
      preferences: allCookies,
      statisticsAnalyticsCookies: allCookies,
      marketingCookies: allCookies,
    };

    setCookies(cookies);
  },

  root: null,
};

window.CWC.loaded();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
